import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { Service } from './types';

interface ServicesState {
  items: Service[];
  loading: boolean;
  error: string | null;
}

const initialState: ServicesState = {
  items: [],
  loading: false,
  error: null,
};

const servicesSlice = createSlice({
  name: 'services',
  initialState,
  reducers: {
    fetchServicesRequested(state) {
      state.loading = true;
      state.error = null;
    },
    fetchServicesSucceeded(state, action: PayloadAction<Service[]>) {
      state.loading = false;
      state.items = action.payload;
    },
    fetchServicesFailed(state, action: PayloadAction<string>) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { fetchServicesRequested, fetchServicesSucceeded, fetchServicesFailed } =
  servicesSlice.actions;

export default servicesSlice.reducer;
